import { Clickable } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { Colors, Font } from 'web-common/src/shared/styles';

export const FollowersContainer = styled.div`
  overflow-y: auto;
  max-height: calc(100vh - 120px);
`;

export const Link = styled(Clickable).attrs(() => ({
  styleAsLink: true,
}))`
  color: ${Colors.GRAY_DARK_10};
  font-weight: 300;
  padding: 0;
  ${Font.bySize(Font.Size.S)}
`;
